import React from 'react';
import { ErrorMessage } from 'formik';

import ShippingAddress, {
  AddressType,
} from './ShippingAddress/ShippingAddress';
import ShippingNewAddress from './ShippingNewAddress/ShippingNewAddress';
import { useCustomer } from 'hooks/useCustomer';

import styles from './ShippingAddresses.module.scss';

export default function ShippingAddresses({
  fieldName,
}: {
  fieldName: string;
}): JSX.Element {
  const { customer } = useCustomer();
  const { addresses } = { ...customer };
  const hasSecondAddress = (addresses?.['S'] ?? null) !== null;

  if (!customer || !addresses) {
    return <div className={styles.addresses}></div>;
  }

  return (
    <div className={styles.addresses}>
      {Object.keys(addresses).map(key => (
        <ShippingAddress
          key={key}
          type={key as AddressType['Primary'] | AddressType['Secondary']}
          customer={customer}
          address={addresses[key]}
          fieldName={fieldName}
        />
      ))}
      {!hasSecondAddress && <ShippingNewAddress customer={customer} />}
      <ErrorMessage name={fieldName} />
    </div>
  );
}
